import { Box, Card, CardHeader, CardBody, Heading, Text, Button } from '@chakra-ui/react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { EmailInvoiceForm } from '@/components/forms/EmailInvoiceForm'
import { shippingLineNameFromSearchParams } from '@/lib/navigation/financialStatementsSearchParams'

export default function EmailInvoiceToClientPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const params = useParams<{ shippingLineId: string; invoiceId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const invoiceIdFromParams = params.invoiceId ? parseInt(params.invoiceId, 10) : undefined

  const shippingLineName = shippingLineNameFromSearchParams(searchParams)
  const finalShippingLineId = paramsShippingLineId
  const finalInvoiceId = invoiceIdFromParams
  const validInvoiceId =
    typeof finalInvoiceId === 'number' && Number.isFinite(finalInvoiceId) ? finalInvoiceId : null

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Email Invoice to Client
            </Heading>
          </CardHeader>
          <CardBody>
            {validInvoiceId == null ? (
              <Box>
                <Text color={colors.textSecondary} mb={4}>
                  Invalid Invoice. Cannot send email.
                </Text>
                <Button size="sm" variant="outline" onClick={handleCancel}>
                  Cancel
                </Button>
              </Box>
            ) : (
              <EmailInvoiceForm
                shippingLineName={shippingLineName}
                invoiceId={validInvoiceId}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
              />
            )}
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
